/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_DqInputs */



/**
* | output |
* | --- |
* | "A player is disqualified — what happens?" |
*
* @param {Og_Faq_Q_DqInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_dq = /** @type {((inputs?: Og_Faq_Q_DqInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_DqInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un joueur est disqualifié — que se passe-t-il ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Un jugador está descalificado — ¿qué ocurre?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Um jogador foi desqualificado — o que acontece?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Un giocatore è squalificato — cosa succede?")
	return /** @type {LocalizedString} */ ("A player is disqualified — what happens?")
});